import { Injectable, signal, Signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private theme = signal<string>(this.loadTheme());

  constructor() {
    // Automatically apply theme on service instantiation
    this.applyTheme(this.theme());
  }

  private loadTheme(): string {
    return localStorage.getItem('theme') || 'light';
  }

  private applyTheme(theme: string) {
    document.documentElement.setAttribute('data-theme', theme);
  }

  getTheme(): Signal<string> {
    return this.theme.asReadonly();
  }

  setTheme(theme: string) {
    localStorage.setItem('theme', theme);
    this.theme.set(theme);
    document.documentElement.setAttribute('data-theme', theme);
  }
  // used in APP_INITIALIZER
  initialize() {
    this.applyTheme(this.theme());
  }

  toggleTheme() {
    this.setTheme(this.theme() === 'light' ? 'dark' : 'light');
  }
}
